"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./SideBar.scss");
var rolePermission_1 = __importDefault(require("./rolePermission"));
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var AdminOrders_1 = __importDefault(require("./AdminOrders"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var Chatting_1 = __importDefault(require("../sellers/Chatting"));
var SellerNotification_1 = __importDefault(require("../sellers/SellerNotification"));
var PAGES = ["Users", "Orders", "Profile", "Chat", "Notifications"];
var Menu_1 = __importDefault(require("@mui/material/Menu"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var Menu_2 = __importDefault(require("@mui/icons-material/Menu"));
var system_1 = require("@mui/system");
var AdminProfile_1 = __importDefault(require("./AdminProfile"));
var functions_1 = require("../../interfaces/functions");
var SideBar = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_1.useState)(PAGES[0]), value = _a[0], setValue = _a[1];
    var theme = (0, material_1.useTheme)();
    var isMatch = (0, material_1.useMediaQuery)(theme.breakpoints.down("md"));
    var _b = react_1.default.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var token = (0, functions_1.getCookie)("token");
    if (token) {
        var role = (0, functions_1.getCookie)("role");
        if (role) {
            if (role !== "admin") {
                js_cookie_1.default.remove("token");
                js_cookie_1.default.remove("role");
                window.location.href = "/login";
            }
        }
    }
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    var handleLogout = function () {
        js_cookie_1.default.remove("token");
        navigate("/login");
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.AppBar, { color: "primary" },
            react_1.default.createElement(material_1.Toolbar, null,
                react_1.default.createElement(material_1.Typography, { sx: { fontSize: "1.5rem", paddingLeft: "2px" } }, "!SHOP ADMIN"),
                isMatch ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(system_1.Box, { sx: { position: "absolute", right: "5px", top: "5px" } },
                        react_1.default.createElement(material_1.IconButton, { id: "fade-button", "aria-controls": open ? "fade-menu" : undefined, "aria-haspopup": "true", "aria-expanded": open ? "true" : undefined, onClick: handleClick, sx: { float: "right" } },
                            react_1.default.createElement(Menu_2.default, { color: "secondary" })),
                        react_1.default.createElement(Menu_1.default, { id: "fade-menu", MenuListProps: {
                                "aria-labelledby": "fade-button",
                            }, anchorEl: anchorEl, open: open, onClose: handleClose }, PAGES.map(function (page, index) { return (react_1.default.createElement(MenuItem_1.default, { key: index, onClick: function () {
                                setValue(PAGES[index]);
                                handleClose();
                            } },
                            react_1.default.createElement(material_1.Tab, { label: page, value: page }))); }))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(material_1.Tabs, { sx: { marginLeft: "auto" }, textColor: "inherit", value: value, onChange: handleChange, indicatorColor: "primary" }, PAGES.map(function (page, index) { return (react_1.default.createElement(material_1.Tab, { key: index, label: page, value: page })); })),
                    react_1.default.createElement(material_1.Button, { sx: { marginLeft: "auto", backgroundColor: "#1A120B" }, variant: "contained", onClick: handleLogout }, "LOGOUT"))))),
        value === "Users" && react_1.default.createElement(rolePermission_1.default, null),
        value === "Orders" && react_1.default.createElement(AdminOrders_1.default, null),
        value === "Profile" && react_1.default.createElement(AdminProfile_1.default, null),
        value == "Chat" && react_1.default.createElement(Chatting_1.default, null),
        value == "Notifications" && react_1.default.createElement(SellerNotification_1.default, null)));
};
exports.default = SideBar;
